import React from 'react';
import { Link } from 'react-router';
import { Autocomplete, TextField, Box, FormHelperText } from '@mui/material';
import { useSelector } from 'react-redux';

import { buildKeyOptions } from './utils';
import ENVIRONMENT_KEY_TYPES from './environmentKeyTypes';

export default function ProjectCredentialsField({ value, onChange, edit }) {
  const project_credentials = useSelector((state) => state.projectCredentials);

  const all_options = buildKeyOptions(
    ENVIRONMENT_KEY_TYPES,
    project_credentials,
  );

  // Convert to Autocomplete format
  const options = all_options.map((option) => ({
    value: option.value,
    label: option.text,
    disabled: option.disabled,
  }));

  // Map selected values to Autocomplete format
  const selectedValues = (value || []).map((val) => {
    const option = options.find((opt) => opt.value === val);
    return option || { value: val, label: val };
  });

  const handleChange = (event, newValue) => {
    const selected_types = newValue.map((option) => option.value);
    onChange(selected_types);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        id='worker-key-types'
        options={options}
        value={selectedValues}
        onChange={handleChange}
        disabled={edit}
        disablePortal
        isOptionEqualToValue={(option, val) => option.value === val.value}
        getOptionLabel={(option) => option.label || ''}
        getOptionDisabled={(option) => option.disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label='Project Credentials'
            aria-describedby='project-credentials-helper-text'
          />
        )}
      />
      <FormHelperText id='project-credentials-helper-text'>
        Project Credentials Disabled?{' '}
        <Link
          to='/account/settings'
          target='_blank'
          style={{ textDecoration: 'none' }}
        >
          Add Project Credentials Here
        </Link>
      </FormHelperText>
    </Box>
  );
}
